/* eslint-disable no-case-declarations */
import * as types from 'features/settings/myParkdSettingsActions';
import { REHYDRATE } from 'redux-persist';
import { ColumnVisibility } from 'screens/modals/ManageTableColumnsModal';
import { ReduxState } from 'types';


// TODO: should we rename to avoid migration issues in localStorage?
export type MyParkdUserSettings = {
    starRatingBoxIsHidden?: boolean,
    parkingSessionsColumnSettings?: ColumnVisibility,
    parkingSessionsOffstreetColumnSettings?: ColumnVisibility,
    vehiclesTableColumnSettings?: ColumnVisibility,
    usersTableColumnSettings?: ColumnVisibility
}

export type MyParkdSettingsByUserId = {
    [userId: number]: MyParkdUserSettings
}

const defaultState: MyParkdSettingsByUserId = {};

export default function myParkdSettings(state = defaultState, action: any) {

    switch (action.type) {
        case types.UPDATE_MYPARKD_SETTING_START:
            const key = action.payload.key;
            const value = action.payload.value;
            const userId = action.payload.userId;
            return {
                ...state,
                [userId]: {
                    ...state[userId],
                    [key]: value
                }
            };

        case REHYDRATE:
            const incoming = action.payload && action.payload.myParkdSettings;
            return {
                ...state,
                ...incoming
            };

        default:
            return state;
    }
}

export const getMyParkdUserSettings = (state: ReduxState): MyParkdUserSettings => {
    return state?.myParkdSettings[state?.user?.user?.id!] ?? {}
}
